<template>
  <div class="layout-main">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">日期: </div>
            <DatePicker @on-change="selectDate" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px"></DatePicker>
            
          </li>
          <li class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                <Select v-model="searchfield" slot="prepend" style="width: 80px">
                    <Option value="name">店铺名</Option>
                </Select>
                <Button @click="request" slot="append" icon="ios-search"></Button>
            </Input>
           
          </li>
        </ul>
      </div>
      <Divider dashed />
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="user">
          <strong>{{ row.user.username }}</strong>
        </template>
        <template slot-scope="{ row }" slot="compare">
          <strong :color="row.compare > 0 ? 'red' : 'green'">{{ row.compare }}%</strong>
        </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
</div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";
export default {
  components: {
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        daterange: ''
      },
      columns: [
          {
              title: '用户名',
              slot: 'user'
          },
          {
              title: '添加问题数量',
              key: 'add_count'
          },
          {
              title: '同比增长',
              slot: 'compare'
          },
          {
              title: '最近添加时间',
              key: 'create_time_text'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    selectitem (key, value) {
      this.filter[key] = value;
      this.request();
    },
    selectDate (date1) {
      if (date1[0]) {      
        this.filter['daterange'] = date1[0]+' - '+date1[1];
      } else {
        this.filter['daterange'] = '';
      }
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("daterange", this.filter.daterange );
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.knowAddrecord(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.product-item {
  display:flex;
  padding: 5px 0px;

  .item-image {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .item-wrap {
    padding-left: 10px;

    .item-title {
      max-width: 150px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap; 
      font-weight:bold;
    }
  }
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
